module.exports = __webpack_public_path__ + "img/trial4-3.3e19b71f.png";